import * as _ from 'lodash';
import { ErrorInfo } from './ErrorInfo';

angular.module("twshared").directive("ergoError", ['ergoErrorParser', function (ergoErrorParser) {
    return {
        restrict: "EA",
        template: require('./ergoError.html'),
        scope: {},
        link: function (scope, element, attributes) {
            element.addClass('ergoError');
            scope.error = null;
            scope.$parent.$watch(attributes.ergoError, function (err) {
                if (err == null) {
                    scope.error = null;
                } else if (err instanceof ErrorInfo) {
                    scope.error = err;
                } else {
                    scope.error = ergoErrorParser(err);
                }

                if (scope.error != null) {
                    scope.messages = scope.error.messages;
                } else {
                    scope.messages = null;
                }
            });
        }
    };
}]);
